module.exports = __webpack_public_path__ + "static/media/b.8e239ebb.JPG";